import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Instance } from 'src/app/models/instance/instance';
import { ServerMessageResponse } from '../../models/server-message-response';
import { FabricService } from 'src/app/services/fabric/fabric.service';
import { convertDates } from '../util/utils';
import { CONFIGURATION_STATE_DATE_FIELDS } from 'src/app/models/configurations/configuration-state';

const SERVICE_NAME = 'instance-resources';

@Injectable({
  providedIn: 'root'
})
export class InstancesService {

  constructor(private fabricService: FabricService) {

  }

  getInstancesForBlueprint(blueprintId: string): Observable<Instance[]> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_instances', {blueprintId});
  }

  getInstancesForSolution(solutionId: string): Observable<Instance[]> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_instances', {solutionId});
  }

  getInstances(): Observable<Instance[]> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_instances');
  }

  getInstanceById(id: string): Observable<Instance> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_instances_id', {id});
  }

  deleteInstance(id: string): Observable<ServerMessageResponse> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'delete_instances_id', {id});
  }

  redeployInstance(id: string): Observable<ServerMessageResponse> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_instances_id_redeploy', {id});
  }

  terminateInstance(id: string): Observable<ServerMessageResponse> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'delete_instances_id_terminate', {id});
  }

  applyDefinition(blueprintVersionId: string, instanceId: string): Observable<Instance> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_instances_id_extend', {blueprintVersionId, id: instanceId});
  }

  applySecrets(secrets?: any, instanceId?: string): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_instances_id_secrets', {id: instanceId, secrets});
  }

  getSecrets(instanceId?: string): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_instances_id_secrets', {id: instanceId});
  }

  applyLocalConfig(id: string, type: any): any {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_instances_id_apply-local-config', {id, type});
  }

  executeRVTState(configurationId: string, instanceId: string): Observable<void> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_instances_id_test',
    {id: instanceId, configurationId});
  }

  getRVTStates(instanceId: string): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_instances_id_test',
    {id: instanceId}).pipe(map(testingStates => {
      testingStates?.data?.forEach(testingState => {
        convertDates(testingState, CONFIGURATION_STATE_DATE_FIELDS);
      });
      return testingStates;
    }));
  }

  getRVTState(instanceId: string, testId: string): Observable<void> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_instances_id_test_testid',
    {id: instanceId, testId});
  }
}
